/* eslint-disable no-undef */
import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as DropdownIcon } from '../../icons/dropdown-arrow.svg';

import './Dropdown.less';

export const Dropdown = (props) => {
  const { items, filter, placeholder, callback, title, theme } = props;

  const [toggleOpen, setToggleOpen] = useState(false);

  const dropdownRef = useRef();

  const handleDropdown = (c) => {
    callback(c);
  };

  useEffect(() => {
    const handler = (e) => {
      if (!dropdownRef.current.contains(e.target)) {
        setToggleOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className={`custom-dropdown cd-${theme}`} data-testid="dropdown-button" onClick={() => setToggleOpen(!toggleOpen)} ref={dropdownRef}>
      <div className={filter ? 'active' : ''}>{filter || placeholder}</div>
      {toggleOpen ? (
        <div className="dropdownWrapper">
          {items.map((c, i) => (
            <div
              key={`item-${i}`}
              className={`dropdownOption ${c[title || 'name'] === filter ? 'selected-op' : ''}`}
              onClick={() => handleDropdown(c)}
            >
              {c[title || 'name']}
            </div>
          ))}
        </div>
      ) : null}
      <div className="arrow-container">
        <DropdownIcon color={!toggleOpen ? '#4A5866' : '#06b2bc'} />
      </div>
    </div>
  );
};
